import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./view.logo";

const LINKS = [
    { href: "#features", label: "Fonctionnalités" },
    { href: "#how", label: "Comment ça marche" },
    { href: "#pricing", label: "Tarifs" },
    { href: "#join", label: "Professionnels" },
];

export default function ViewNavbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const solid = scrolled || open;

    return (
        <nav className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${solid ? "bg-white/85 backdrop-blur-xl shadow-[0_1px_0_rgba(26,18,71,0.06)]" : "bg-transparent"}`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <a href="#top" className="flex items-center gap-2.5" aria-label="Medic'help, accueil">
                        <Logo size={34} />
                        <span className={`text-xl font-extrabold tracking-tight ${solid ? "text-brand-950" : "text-white"}`}>Medic'help</span>
                    </a>
                    <div className="hidden md:flex items-center gap-8">
                        {LINKS.map((l) => (
                            <a key={l.href} href={l.href} className={`text-sm font-semibold transition-colors ${solid ? "text-slate-600 hover:text-brand-600" : "text-white/80 hover:text-white"}`}>{l.label}</a>
                        ))}
                        <a href="#download" className={`text-sm font-bold px-4 py-2 rounded-full transition-all ${solid ? "bg-brand-500 text-white hover:bg-brand-600" : "bg-white text-brand-700 hover:bg-brand-50"}`}>
                            Télécharger
                        </a>
                    </div>
                    <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
                        className={`md:hidden p-2 -mr-2 rounded-xl ${solid ? "text-brand-950" : "text-white"}`}>
                        {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                </div>
            </div>
            {open && (
                <div className="md:hidden border-t border-slate-100 bg-white px-4 pb-5 pt-2">
                    {LINKS.map((l) => (
                        <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block py-3 text-base font-semibold text-slate-700 border-b border-slate-100">{l.label}</a>
                    ))}
                    <a href="#download" onClick={() => setOpen(false)} className="mt-4 block text-center font-bold py-3 rounded-xl bg-brand-500 text-white">Télécharger l'app</a>
                </div>
            )}
        </nav>
    );
}
